import { useState } from "react";

export function CloseIcon({ onClick }) {
  const [hovered, setHovered] = useState(false);

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ cursor: "pointer" }}
      onClick={onClick}
      id="x-icon"
    >
      <path
        d="M18.75 5.25L5.25 18.75"
        stroke={hovered ? "#1b1c1cff" : "#676C7E"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transition: "all 0.3s ease-out" }}
      />
      <path
        d="M18.75 18.75L5.25 5.25"
        stroke={hovered ? "#1b1c1cff" : "#676C7E"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ transition: "all 0.3s ease-out" }}
      />
    </svg>
  );
}
